import { InjectionToken } from '@angular/core';
import type { ApprovalAchReceiptsRepository } from '../contracts/approval-ach-receipts.repository';

export const APPROVAL_ACH_RECEIPTS_REPOSITORY_TOKEN =
  new InjectionToken<ApprovalAchReceiptsRepository>(
    'APPROVAL_ACH_RECEIPTS_REPOSITORY_TOKEN'
  );
